export const users = (
    eventId = ':event'
) => `events/${eventId}/users`;
